import LoadingObject, { LoadingObjectType } from '@/components/view/atoms/loading/LoadingObject'
import Table from '@/components/view/atoms/table/Table'
import TableRow from '@/components/view/atoms/table/TableRow'
import TableRowItem from '@/components/view/atoms/table/TableRowItem'
import SortButtonList from '@/components/view/layouts/button/SortButtonList'

const Row = () => (
  <TableRow>
    <TableRowItem checkbox>
      <LoadingObject type={LoadingObjectType.THUMBNAIL_MICRO} />
    </TableRowItem>
    <TableRowItem width={200}>
      <LoadingObject />
    </TableRowItem>
    <TableRowItem width={200}>
      <LoadingObject />
    </TableRowItem>
    <TableRowItem width={200}>
      <LoadingObject />
    </TableRowItem>
    <TableRowItem width={200}>
      <LoadingObject />
    </TableRowItem>
    <TableRowItem width={320}>
      <LoadingObject />
    </TableRowItem>
  </TableRow>
)

const ListFormLoading = () => {
  return (
    <>
      <div className='flex items-center justify-between px-3 py-2'>
        <SortButtonList>
          <LoadingObject type={LoadingObjectType.INPUT} />
          <LoadingObject type={LoadingObjectType.INPUT} />
          <LoadingObject type={LoadingObjectType.INPUT} />
        </SortButtonList>
        <div className='max-w-[200px] flex-1'>
          <LoadingObject type={LoadingObjectType.TEXT} />
        </div>
      </div>
      <LoadingObject type={LoadingObjectType.LINE} />
      <Table>
        <tbody>
          {[...Array(10)].map((_, index) => (
            <Row key={index} />
          ))}
        </tbody>
      </Table>
    </>
  )
}

export default ListFormLoading
